import {Component, ViewChild, ElementRef, Renderer, OnDestroy} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {FamilyAlbum} from "../../../model/family-album";
import {BusinessService} from "../../../services/data/business.service";
import {Picture} from "../../../model/picture";
import {UrlService} from "../../../services/url.service";
import {Business} from "../../../model/business";
import {AuthentService} from "../../../services/authent.service";
import {Page} from "../../../model/page";
import {WallPicture} from "./wall-picture";
import {Wall} from "../../../model/wall";
import {FileUploader, FileUploaderOptions, ParsedResponseHeaders} from "ng2-file-upload";
import {FamiliesFileItem} from "../../../app.component";
import {PhotoWallService} from "../../../services/data/photo-wall.service";
import {Subscription} from "rxjs";

declare const $: any;
declare const document: any;
declare const flux: any;

@Component({
  selector: 'diaporama',
  template: require('./diaporama.component.html'),
  styles: [
    require('./diaporama.component.scss')
  ]
})

export class DiaporamaComponent implements OnDestroy {

  INTERVAL_CHANGE: number = 7000;
  INTERVAL_LOAD: number = 30000;

  fullPicture: WallPicture;

  event: FamilyAlbum;

  pictures: WallPicture[] = [];

  wallIndexes = [0, 1, 2, 3, 4, 5, 6, 7, 8];
  currentWallIndex = 0;
  picturesToShow: WallPicture[] = [];
  picturePage: Page<Picture>;
  pageNumber: number = 0;
  lastPage: boolean = false;
  isLoadingPicture: boolean = false;

  business: Business = new Business();

  lastUpdate: number = new Date().getTime();
  lastIndex: number = 0;

  initialized: boolean = false;

  last: number = 1;

  connected: boolean = false;

  photowall: Wall;

  uploader: FileUploader;
  uploaderOptions: FileUploaderOptions = {};
  uploading: boolean = false;

  logoIndex: number;

  fullscreen: boolean = false;

  nbRows: number = 3;
  resolution: string = 'low';

  @ViewChild('logoInput') fileInput: ElementRef;

  private paramSubscription: Subscription = null;

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
  }

  constructor(private activatedRoute: ActivatedRoute, private businessService: BusinessService,
              private urlService: UrlService, private authent: AuthentService,
              private wallService: PhotoWallService, private renderer: Renderer) {
    $('nav-bar').remove();

    this.paramSubscription = activatedRoute.params.subscribe(
      (param: any) => {
        let eventId = param['eventId'];

        businessService.getEvent(eventId).subscribe(event => {
          this.eventLoaded(event)
        });

        this.connected = true;
        this.initUploader();
      });

    $('body').css('overflow', 'hidden');
  }

  initUploader() {
    this.uploader = new FileUploader({
      autoUpload: true
    });

    this.setUploaderToken();

    this.uploader.onSuccessItem = (item: FamiliesFileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      let picture = JSON.parse(response);

      this.updateLogo(picture);
      this.uploading = false;
    };

    this.uploader.onErrorItem = (item: any, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (response != null && response != '') {
        let error = JSON.parse(response);

        if (error.errors[0].code == 'constraint.violation') {
          item.errorMessage = 'Mauvais format';
        }

        console.log("onErrorItem " + status, response);
      } else {
        item.errorMessage = 'Erreur d\'ajout';
      }
      this.uploading = false;
    };

    this.uploader.onAfterAddingFile = (item: FamiliesFileItem) => {
      this.uploading = true;
      item.withCredentials = false;
      item.eventId = this.event.id;
      item.url = this.urlService.getPhotoWallLogoAddUrl(this.event.id, this.logoIndex);
      let headers = {
        name: 'Authorization',
        value: 'Bearer ' + this.authent.getToken()
      };
      item.headers = headers;
    }
  }

  updateLogo(picture: Picture) {
    if (this.logoIndex == 1) {
      this.photowall.logo1 = picture.id;
      this.photowall.logo1Url = this.urlService.getPhotowallLogoUrl(this.event.id, picture.id);
    }

    if (this.logoIndex == 2) {
      this.photowall.logo2 = picture.id;
      this.photowall.logo2Url = this.urlService.getPhotowallLogoUrl(this.event.id, picture.id);
    }

    if (this.logoIndex == 3) {
      this.photowall.logo3 = picture.id;
      this.photowall.logo3Url = this.urlService.getPhotowallLogoUrl(this.event.id, picture.id);
    }

    this.logoIndex = null;
  }

  setUploaderToken() {
    let headers = {
      name: 'Authorization',
      value: 'Bearer ' + this.authent.getToken()
    };

    this.uploader.options.itemAlias = 'attachment';
    this.uploaderOptions.headers = [headers];
    this.uploader.setOptions(this.uploaderOptions);
  }

  eventLoaded(event: FamilyAlbum) {
    this.event = event;

    this.wallService.getPhotoWall(event.id).subscribe(photowall => this.loadedWall(photowall));

    this.business.logoPath = this.urlService.getUploadBusinessLogoUrl(this.event.businessId) + '?access_token=' + this.authent.getToken();

    this.launchTimers();
  }

  loadedWall(photowall: Wall) {
    if (photowall.logo1 != null) {
      photowall.logo1Url = this.urlService.getPhotowallLogoUrl(this.event.id, photowall.logo1);
    }
    if (photowall.logo2 != null) {
      photowall.logo2Url = this.urlService.getPhotowallLogoUrl(this.event.id, photowall.logo2);
    }
    if (photowall.logo3 != null) {
      photowall.logo3Url = this.urlService.getPhotowallLogoUrl(this.event.id, photowall.logo3);
    }

    this.resolution = photowall.resolution;
    this.nbRows = photowall.rows;
    this.photowall = photowall;
    this.photowall.color = photowall.color;

    setTimeout(function () {
      $('.wall-page').each(function () {
        this.style.display = 'none';
        this.offsetHeight;
        this.style.display = 'inline-block';
      });
    }, 400);
  }

  addLogo(index: number) {
    this.logoIndex = index;

    let event = new MouseEvent('click', {bubbles: true});

    this.renderer.invokeElementMethod(
      this.fileInput.nativeElement, 'dispatchEvent', [event]);
  }

  setLogoToDelete(index: number) {
    this.logoIndex = index;
  }

  cancelLogoDelete() {
    this.logoIndex = null;
  }

  deleteLogo() {
    this.wallService.deleteLogo(this.event.id, this.logoIndex).subscribe(
      state => {
        if (this.logoIndex == 1) {
          this.photowall.logo1 = null;
          this.photowall.logo1Url = null;
        }

        if (this.logoIndex == 2) {
          this.photowall.logo2 = null;
          this.photowall.logo2Url = null;
        }

        if (this.logoIndex == 3) {
          this.photowall.logo3 = null;
          this.photowall.logo3Url = null;
        }

        this.logoIndex = null;
      }
    );
  }

  public nbRowsChange(nb) {
    this.nbRows = nb;
    this.photowall.rows = this.nbRows;
    this.updateWall();
  }

  public resolutionChange(resolution) {
    this.resolution = resolution;
    this.photowall.resolution = this.resolution;
    this.updateWall();
  }

  getColor() {
    return this.photowall.color;
  }

  updateWall() {
    this.wallService.updatePhotoWall(this.event.id, this.photowall).subscribe();
  }

  lastPicturesLoaded(pictures: Picture[]) {

    this.picturesToShow = this.picturesToShow.filter((picture)=>{
      if(picture.isNew) {
        return true;
      } else {
        return false;
      }
    });

    for (let picture of pictures) {
      if (this.picturesToShow.length >= 20) {
        break;
      }

      picture.miniatureUrl = this.urlService.getPictureMiniatureUrl(this.event.id, picture.id);
      picture.url = this.urlService.getPictureUrl(this.event.id, picture.id);

      let wallPicture = new WallPicture(picture);
      wallPicture.isNew = true;

      this.picturesToShow.push(wallPicture);
    }

    if (this.picturesToShow.length < 10) {
      this.loadPictures();
    }
  }

  loadPictures(page?: number) {
    this.isLoadingPicture = true;

    if (page == null) {
      if (this.lastPage) {
        this.pageNumber = 1;
      } else {
        this.pageNumber++;
      }
    } else {
      this.pageNumber = page;
    }

    this.businessService.eventPictures(this.event.id, this.pageNumber, 10).subscribe(
      page => this.picturesLoaded(page)
    );
  }

  picturesLoaded(page: Page<Picture>) {
    this.picturePage = page;

    for (let picture of page.content) {
      if (this.picturesToShow.length >= 20) {
        break;
      }

      picture.miniatureUrl = this.urlService.getPictureMiniatureUrl(this.event.id, picture.id);
      picture.url = this.urlService.getPictureUrl(this.event.id, picture.id);

      let wallPicture = new WallPicture(picture);
      wallPicture.isNew = false;

      this.picturesToShow.push(wallPicture);
    }

    this.lastPage = page.last;
    this.isLoadingPicture = false;

    if (!this.initialized) {
      this.initialized = true;
    }
  }

  changePicture() {

    if (this.picturesToShow.length > 0) {

      let h = $('.pictures-container-' + this.last).outerHeight();
      let ratio = h / this.picturesToShow[0].picture.height;
      let width = this.picturesToShow[0].picture.width * ratio;
      this.picturesToShow[0].picture.width = 0;

      this.pictures.unshift(this.picturesToShow[0]);
      // this.fullPicture = this.picturesToShow[0];

      let pictureToShow = this.picturesToShow[0];

      $(".central-picture img").one("load", function() {
        $(".central-picture img").hide().fadeIn(500);
      }).attr("src", pictureToShow.picture.url);

      this.picturesToShow.shift();

      let $picture = $('.item-' + this.last + '-' + this.pictures[this.pictures.length - 1].picture.id);
      let length = $picture.length;

      if (length > 0) {
        if (!this.isElementInViewport($picture[length - 1])) {
          this.pictures.pop();
        }
      }
    }


  }

  private isElementInViewport(el) {
    var rect = el.getBoundingClientRect();

    return (
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  launchTimers() {
    let that = this;

    that.businessService.getLastWallPictures(that.event.id, that.lastUpdate).subscribe(
      pictures => {
        if (pictures.length > 0) {
          that.lastPicturesLoaded(pictures);
        } else {
          that.loadPictures();
        }
      }
    );

    setInterval(function () {
      that.businessService.getLastWallPictures(that.event.id, that.lastUpdate).subscribe(
        pictures => {
          if (pictures.length > 0) {
            that.lastPicturesLoaded(pictures);
          } else {
            that.loadPictures();
          }

          that.lastUpdate = new Date().getTime();
        }
      );
    }, this.INTERVAL_LOAD);

    setInterval(function () {
      that.changePicture();
    }, this.INTERVAL_CHANGE);
  }

  getIndex() {
    this.currentWallIndex++;

    if (this.currentWallIndex > 8) {
      this.currentWallIndex = 0;
    }

    return this.wallIndexes[this.currentWallIndex];
  }

  shuffle(a) {
    for (let i = a.length; i; i--) {
      let j = Math.floor(Math.random() * i);
      [a[i - 1], a[j]] = [a[j], a[i - 1]];
    }

  }

  toggleFullScreen() {
    if ((document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      }

      setTimeout(function () {
        $('.logo').each(function () {
          this.style.display = 'none';
          this.offsetHeight;
          this.style.display = 'inline-block';
        });
      }, 200);
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/event/diaporama/diaporama.component.ts